import { css } from 'styled-components';
import PropTypes from 'prop-types';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["border-radius:", ";"], function (props) {
  return props.circular ? "50%" : 0;
});
/**
 * Renders an `img` element with some default styles.
 *
 * @public
 * @author Anna Richardson
 */

var Image = makeThemedComponent({
  themeKey: "Image",
  component: "img",
  defaultStyles: defaultStyles
});
Image.defaultProps = {
  circular: false
};
Image.propTypes = {
  circular: PropTypes.bool
};
export { defaultStyles };
/** @component */

export default Image;